import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonComponent } from '@shared/components/ui/button';

@Component({
  selector: 'lib-error-state',
  standalone: true,
  imports: [TranslateModule, ButtonComponent],
  templateUrl: './error-state.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorStateComponent {
  readonly errorTitle = input<string>('DASHBOARD.CARDS.SOMETHING_WRONG');
  readonly subtitle = input<string>('DASHBOARD.CARDS.COULD_NOT_PROCCESS');
  readonly buttonLabel = input<string>('DASHBOARD.CARDS.RELOAD');
  readonly retry = output<void>();
}
